import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        minHeight: 400,
        backgroundColor: theme.palette.background.paper,
    },
}));

export default function ListD(props) {
    const classes = useStyles();

    return (
        <List component="nav" className={classes.root} aria-label="mailbox folders">
            <ListItem button onClick={()=>props.changeFragment('Approval')}>
                <ListItemText primary="Approval" />
            </ListItem>
            <Divider />
            <ListItem button  onClick={()=>props.changeFragment('Certificate')} divider>
                <ListItemText primary="Certificate" />
            </ListItem>
            <ListItem button  onClick={()=>props.changeFragment('General')} divider>
                <ListItemText primary="General" />
            </ListItem>
            <Divider light />
        </List>
    );
}